module.exports = __webpack_public_path__ + "static/media/snow_legend_v6.da377dda.png";